import { render, staticRenderFns } from "./OperaUserWindow.vue?vue&type=template&id=ca1f9c3a&scoped=true&"
import script from "./OperaUserWindow.vue?vue&type=script&lang=js&"
export * from "./OperaUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaUserWindow.vue?vue&type=style&index=0&id=ca1f9c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1f9c3a",
  null
  
)

export default component.exports